<ion-header [hidden]="scanCamera">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
            Artikel info
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content [hidden]="scanCamera">
    <mat-card>
        <ion-item lines="none">
            <input list='artlisting' placeholder="Artikel nummer" class="inputField" onclick="this.select()"
                (input)='artChanged($any($event.target).value)' [(ngModel)]='inpArtnr'>
            <!--
        <datalist id='artlisting'>
          <option *ngFor="let art of artlist"  [value]="art.nr">{{art.des}}</option>
        </datalist>
        -->
            <ion-button size="small" (click)="doScan()" [hidden]="global.optHideScanBtn">
                <ion-icon name="barcode"></ion-icon>
            </ion-button>
        </ion-item>
        <ion-item *ngIf="artlist.length && artlist.length>0">
            <ion-list style="max-height: 300px; overflow-y: scroll; width: 100%;">
                <ion-item *ngFor="let art of artlist">
                    <ion-label (click)="click_art(art.nr)">{{ art.des }}</ion-label>
                </ion-item>
            </ion-list>
        </ion-item>
        <ng-container *ngIf="!artlist.length || artlist.length==1">
            <ion-item lines="none">
                <ion-thumbnail slot='end' [hidden]="!artShow.metFoto">
                    <ion-img [src]='artShow.imgUrl' (click)="viewerOpen=true"></ion-img>
                </ion-thumbnail>
                <ion-label>
                    {{artShow.descr}}
                    <span *ngIf="artShow.note"><br><span [innerHTML]="artShow.note"></span></span>
                </ion-label>
            </ion-item>
            <table>
                <tr>
                    <td vAlign="top">
                        <table class="taglist">
                            <tr>
                                <td>
                                    <ion-button size='small' *ngIf="magVoorraadWijz" (click)="chLoc()">
                                        <ion-icon name="pencil"></ion-icon>
                                    </ion-button>
                                </td>
                                <td class="tag">Locatie</td>
                                <td class="value" colspan="2">{{artShow.locatie}}</td>
                                <td class="mobile">
                                    <span class="tag">Locatie</span><br>
                                    {{artShow.locatie}}
                                </td>
                            </tr>
                            <tr *ngIf="magVoorraadWijz && !global.optHideScanBtn">
                                <td>
                                    <ion-button size='small' (click)="doScanEAN()" [hidden]="global.optHideScanBtn">
                                        <ion-icon name="barcode"></ion-icon>
                                    </ion-button>
                                </td>
                                <td class="tag">EAN</td>
                                <td class="value" colspan="2">{{artShow.ean}}</td>
                                <td class="mobile">
                                    <span class="tag">EAN</span><br>
                                    {{artShow.ean}}
                            </tr>
                            <tr>
                                <td>
                                    <ion-button size='small' *ngIf="magVoorraadWijz" (click)="telling()">
                                        <ion-icon name="pencil"></ion-icon>
                                    </ion-button>
                                </td>
                                <td class="tag">Voorraad</td>
                                <td class="value" align="right">{{artShow.voorraad}}</td>
                                <td class="tag">{{artShow.eenh}}</td>
                                <td class="mobile">
                                    <span class="tag">Voorraad</span><br>
                                    {{artShow.voorraad}} <span class="tag">{{artShow.eenh}}</span>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="tag">Vrije voorraad</td>
                                <td class="value" align="right">{{artShow.vrijevoorraad}}</td>
                                <td class="tag">{{artShow.eenh}}</td>
                                <td class="mobile">
                                    <span class="tag">Vrije voorraad</span><br>
                                    {{artShow.vrijevoorraad}} <span class="tag">{{artShow.eenh}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="tag">Min. Voorraad</td>
                                <td class="value" align="right">{{artShow.minvr}}</td>
                                <td class="tag">{{artShow.eenh}}</td>
                                <td class="mobile">
                                    <span class="tag">Min. Voorraad</span><br>
                                    {{artShow.minvr}} <span class="tag">{{artShow.eenh}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td class="tag">Verbruik/jr</td>
                                <td class="value" align="right">{{artShow.verbruik}}</td>
                                <td class="tag">{{artShow.eenh}}</td>
                                <td class="mobile">
                                    <span class="tag">Verbruik/jr</span><br>
                                    {{artShow.verbruik}} <span class="tag">{{artShow.eenh}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <ion-button size='small'  *ngIf="magVoorraadWijz && !bestelForm" [disabled]="artShow.inkMin<0" (click)="bestelForm=true">
                                        <ion-icon name="add"></ion-icon>
                                    </ion-button>
                                </td>
                                <td class="tag">In bestelling</td>
                                <td class="value" align="right">{{artShow.besteld}}</td>
                                <td class="tag">{{artShow.eenh}}</td>
                                <td class="mobile">
                                    <span class="tag">In bestelling</span><br>
                                    {{artShow.besteld}} <span class="tag">{{artShow.eenh}}</span>
                                </td>
                            </tr>
                            <tr *ngIf="artShow.besteldConcept>0">
                                <td></td>
                                <td class="tag">in concept</td>
                                <td class="value" align="right">{{artShow.besteldConcept}}</td>
                                <td class="tag">{{artShow.eenh}}</td>
                                <td class="mobile">
                                    <span class="tag">in concept</span><br>
                                    {{artShow.besteldConcept}} <span class="tag">{{artShow.eenh}}</span>
                                </td>
                            </tr>
                        </table>
                    </td><td vAlign="top">
                        <table class="taglist" style="padding-left: 20px;">
                            <tr *ngFor="let km of artShow.kenmerken">
                                <td class="tag">{{km.Name}}</td>
                                <td class="value">{{km.Value}}</td>
                                <td class="mobile">
                                    <span class="tag">{{km.Name}}</span><br>
                                    {{km.Value}}
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </ng-container>
    </mat-card>
    <ion-card *ngIf="bestelForm" class="dialogstyle">
        <ion-card-title>Nieuwe bestelling</ion-card-title>
        <ion-card-content>
            <ion-row>
                <ion-col>
                    <table>
                        <tr>
                            <td>
                                <ion-button size='small' [disabled]="BestelAantal<=artShow.inkMin"
                                    (click)="BestelAantal = Math.max(artShow.inkMin, BestelAantal - (BestelAantal-artShow.inkMin) % artShow.inkStp - artShow.inkStp)"
                                >
                                    <ion-icon name="remove"></ion-icon>
                                </ion-button>
                            </td>
                            <td>
                                <ion-item fill="outline">
                                    <ion-input type="number"
                                        label="Aantal" labelPlacement="stacked"
                                        [(ngModel)]="BestelAantal"
                                        [min]="artShow.inkMin" [step]="artShow.inkStp"
                                    ></ion-input>
                            </ion-item>
                        </td>
                            <td>
                                <ion-button size='small'
                                    (click)="BestelAantal = BestelAantal - (BestelAantal-artShow.inkMin) % artShow.inkStp + artShow.inkStp"
                                >
                                    <ion-icon name="add"></ion-icon>
                                </ion-button>
                            </td>
                            <td>{{artShow.eenh}}</td>
                        </tr>
                    </table>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <ion-button size='small' (click)="plaatsBestelling()" [disabled]="(BestelAantal-artShow.inkMin) % artShow.inkStp!==0">
                        Save
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button size='small' fill="outline" (click)="bestelForm=false">
                        Cancel
                    </ion-button>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    Een bestelling zal worden toegevoegd aan een nog te verzenden inkooporder. De order moet later nog verzonden worden naar de leverancier.
                </ion-col>
            </ion-row>
        </ion-card-content>
    </ion-card>

</ion-content>
<ion-fab vertical="bottom" horizontal="end" slot="fixed" [hidden]="scanCamera"
    *ngIf="!artlist.length || artlist.length==1">
    <ion-fab-button [routerLink]="['/afboeking']">
        <ion-icon name="cart"></ion-icon>
    </ion-fab-button>
</ion-fab>

<app-imageview [open]="viewerOpen" [idx]="0" [imgs]="imgs" [ordnr]="" [currSub]=""
    (close)="viewerOpen = false;"></app-imageview>